import * as P from 'pages';
import { ROUTES, WAITING_ROUTES } from 'utils/constants/constants_routes';
export { ROUTES, WAITING_ROUTES };
// Appmap used to render the screens inside Router
export const AppMap = {
  [ROUTES.ONE_TIME_TOKEN_LOGIN_WAITING]: {
    nonDynamicComponent: P.OneTimeTokenLogin,
  },
  [ROUTES.REGISTRATION_AFFILIATE]: {
    nonDynamicComponent: P.OneTimeTokenLogin,
  },
  [ROUTES.FIRST_LOAN]: {
    nonDynamicComponent: P.Introduction,
    authenticated: false, // Setting false explicitly because it's a fallback route for non-authentitated users and it should be always accessible by those
  },
  [ROUTES.FIRST_LOAN_MOBILE]: {
    nonDynamicComponent: P.Introduction,
    authenticated: false,
  },
  [ROUTES.FIRST_LOAN_EMAIL]: {
    nonDynamicComponent: P.Identification,
    authenticated: false,
  },
  [ROUTES.FIRST_LOAN_CONFIRMATION]: {
    nonDynamicComponent: P.Confirmation,
  },
  [ROUTES.FIRST_LOAN_WELCOME]: {
    nonDynamicComponent: P.Welcome,
    authenticated: true,
  },
  //// client registered and authenticated
  [ROUTES.FIRST_LOAN_PERSONAL_DATA]: {
    nonDynamicComponent: P.PersonalData,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ADDRESS]: {
    nonDynamicComponent: P.AddressDetails,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_INCOME]: {
    nonDynamicComponent: P.IncomeDetails,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_PHONE_VERIFICATION]: {
    nonDynamicComponent: P.PhoneVerification,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_PHONE_VERIFICATION_WAITING]: {
    nonDynamicComponent: P.ResolutionResolverPhoneVerification,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_PHONE_VERIFICATION_CHANGE_PHONE]: {
    nonDynamicComponent: P.PhoneVerificationChangePhone,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_INCORRECT_CODE]: {
    nonDynamicComponent: P.IncorrectCode,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ONLINE_BANK_ERROR]: {
    nonDynamicComponent: P.OnlineBankError,
    authenticated: true,
  },
  //// Online Bank:
  [ROUTES.FIRST_LOAN_ONLINE_BANK_VERIFY]: {
    nonDynamicComponent: P.OnlineBankVerification,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ONLINE_BANK_VERIFY_NEW]: {
    nonDynamicComponent: P.OnlineBankVerification,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ONLINE_BANK_CHECK]: {
    nonDynamicComponent: P.OnlineBankWaiting,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ONLINE_BANK_TINK_WAITING]: {
    nonDynamicComponent: P.TinkWaiting,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ONLINE_BANK_APPROVED]: {
    nonDynamicComponent: P.Approved,
    authenticated: true,
  },
  //////// Upload:
  [ROUTES.FIRST_LOAN_ONLINE_BANK_ADD_DOCUMENTS]: {
    nonDynamicComponent: P.RegistrationUploadDoc,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ONLINE_BANK_IBAN]: {
    nonDynamicComponent: P.BankAccount,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ONLINE_BANK_PENDING_WAITING]: {
    nonDynamicComponent: P.RegistrationSuccess,
    authenticated: true,
  },
  ////////
  [ROUTES.FIRST_LOAN_ONLINE_BANK_REJECTED_BY_TINK]: {
    nonDynamicComponent: P.RegistrationRejected,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_ONLINE_BANK_REJECT]: {
    nonDynamicComponent: P.RegistrationRejected,
    authenticated: true,
  },
  // Manual:
  [ROUTES.FIRST_LOAN_MANUAL_UPLOAD]: {
    nonDynamicComponent: P.RegistrationUploadDoc,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_MANUAL_UPLOAD_BANK_ACCOUNT]: {
    nonDynamicComponent: P.BankAccount,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_MANUAL_UPLOAD_WAITING]: {
    nonDynamicComponent: P.RegistrationSuccess,
    authenticated: true,
  },
  // Repeated Loan
  [ROUTES.ACCOUNT_REPEATED_LOAN_CONFIRM]: {
    nonDynamicComponent: P.RepeatedLoanConfirm,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_WAITING]: {
    nonDynamicComponent: P.RegistrationLoading,
    authenticated: true,
  },
  [ROUTES.ACCOUNT_REPEATED_LOAN_WAITING]: {
    nonDynamicComponent: P.RegistrationLoading,
    // component: () => import('./pages/RegistrationLoading/RegistrationLoading'),
    authenticated: true,
  },
  // Affiliate
  [ROUTES.AFFILIATE_PROVIDER_NAME]: {
    nonDynamicComponent: P.AffiliateProvider,
  },
  [ROUTES.AFFILIATE_FIRST_LOAN_APPLICATION]: {
    nonDynamicComponent: P.AffiliateFirstLoan,
    authenticated: undefined,
  },
  [ROUTES.FIRST_LOAN_REJECTED]: {
    nonDynamicComponent: P.RegistrationRejected,
    authenticated: true,
  },
  [ROUTES.ACCOUNT_REPEATED_LOAN_APPROVED_APPLICATION]: {
    nonDynamicComponent: P.RepeatedLoanSuccess,
    authenticated: true,
  },
  [ROUTES.ACCOUNT_REPEATED_LOAN_REJECTED_APPLICATION]: {
    nonDynamicComponent: P.RepeatedLoanRejected,
    authenticated: true,
  },
  [ROUTES.PAYMENT_SUCCESS]: {
    nonDynamicComponent: P.PaymentSuccess,
    authenticated: true,
  },
  [ROUTES.PAYMENT_FAILED]: {
    nonDynamicComponent: P.PaymentFailed,
    authenticated: true,
  },
  [ROUTES.BEST_OFFER]: {
    nonDynamicComponent: P.BestOffer,
    authenticated: true,
  },
  [ROUTES.APPROVED]: {
    nonDynamicComponent: P.Approved,
    authenticated: true,
  },
  '*': {
    nonDynamicComponent: P.NotFound,
  },
  [ROUTES.FIRST_LOAN_TINK_BANK_NA]: {
    nonDynamicComponent: P.TinkBankNA,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_TINK_BANK_ISSUE]: {
    nonDynamicComponent: P.TinkBankIssue,
    authenticated: true,
  },
  [ROUTES.FIRST_LOAN_TINK_LATER]: {
    nonDynamicComponent: P.TinkLater,
    authenticated: true,
  },
  [ROUTES.REJECTED_TIMER]: {
    nonDynamicComponent: P.RejectedTimer,
    authenticated: true,
  },
  // STELO
  [ROUTES.STELO_APPROVED]: {
    nonDynamicComponent: P.Stelo,
    authenticated: true,
  },
  [ROUTES.STELO_REJECTED]: {
    nonDynamicComponent: P.Stelo,
    authenticated: true,
  },
  [ROUTES.STELO_REJECTED_TINK]: {
    nonDynamicComponent: P.Stelo,
    authenticated: true,
  },
};
